import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import { useAuth } from 'hooks/UseAuth'
import { useWorkspace } from 'hooks/useWorkspace'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { observer } from 'mobx-react-lite'
import { WorkspaceProfileForm } from './WorkspaceProfileForm'
import Styles from './WorkspaceSettings.module.scss'
import { WhiteLabelSettings } from './WhiteLabelSettings/WhiteLabelSettings'
import { InterfaceColorSettings } from './InterfaceColorSettings/InterfaceColorSettings'
import { SnippetsSettings } from './SnippetsSettings/SnippetsSettings'
import { ApprovalsSettings } from '../ApprovalsSettings/ApprovalsSettings'
import { Heading } from 'blaze-ui/Heading/Heading'
import { VirtualMarketerUpgradeCta } from './VirtualMarketerUpgradeCta/VirtualMarketerUpgradeCta'
import { useShowVirtualMarketerUpgradeCta } from './VirtualMarketerUpgradeCta/hooks/useShowVirtualMarketerUpgradeCta'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Modal } from 'almanac-ui/Modal'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AutopilotSettings } from './AutopilotSettings/AutopilotSettings'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'

export const WorkspaceSettings = observer(function WorkspaceSettings() {
  const auth = useAuth()
  const workspaceId = auth && auth.company_id
  const workspace = useWorkspace(workspaceId)
  const workspaces = useWorkspaces()
  const isVirtualMarketer = useIsVirtualMarketer()
  const { showCta: showVirtualMarketerUpgradeCta } = useShowVirtualMarketerUpgradeCta()
  const isSettingsModalUpdateEnabled = useFlipperFlag('settings_modal_update')
  const isWhiteLabelEnabled = useFlipperFlag('white_label') && isVirtualMarketer
  const { isMobile } = useResponsiveDesign()
  const { data: brandPlan } = useCurrentBrandPlan()

  if (!workspace) return null

  return (
    <>
      <div className={Styles.workspace}>
        <div>
          {isSettingsModalUpdateEnabled && !isMobile ? (
            <Modal.Header title="General" className={SettingsStyles.newHeader} />
          ) : (
            <header className={SettingsStyles.subHeader}>
              <Heading level={4}>General</Heading>
            </header>
          )}
          {showVirtualMarketerUpgradeCta && <VirtualMarketerUpgradeCta />}
          <div className={Styles.workspaceNameHeading}>
            <Heading level={3}>Workspace name</Heading>
          </div>
          <WorkspaceProfileForm key={workspace.id} workspace={workspace} workspaces={workspaces} />
        </div>

        <div className={Styles.divider} />

        {!workspace.is_whitelabel && (
          <>
            <InterfaceColorSettings workspace={workspace} />
            <div className={Styles.divider} />
          </>
        )}

        {isWhiteLabelEnabled && (
          <>
            <WhiteLabelSettings workspace={workspace} />
          </>
        )}

        {brandPlan?.id && (
          <>
            <div className={Styles.section}>
              <AutopilotSettings brandPlanId={brandPlan.id} />
            </div>
          </>
        )}

        {isVirtualMarketer && (
          <>
            <ApprovalsSettings />
            <div className={Styles.divider} />
          </>
        )}

        <SnippetsSettings />
      </div>
    </>
  )
})
